import swipeTypes from 'areas/swipes/domain/swipeTypes';
import alertActions from 'areas/alert/actions';
import progressActions from 'areas/progress/actions';

import {
    requestCardData,
    receiveCardData
} from 'areas/cards/actions';

import configActions from 'areas/config/actions';
import repository from 'client/repository';
import { processCard } from 'areas/cards/domain';
import { signout, closeAuthCodeDialog } from '.';
import isStringSet from 'utilities/is/isStringSet';
import { updateCardSerial } from 'workers/mediator';
import m from 'messages';

/*
 * This is the final verification step in the authentication process where a QR code and Authentication Code
 * are sent to the server to verify the user.  Once this returns a success indicator, the action will continue
 * to load the initial data needed by the application for this user (card data and supervisor data)
 */
export default function (qrCode, authenticationCode) {

    const actionPrefix = 'CONTINUE';

    function failure(error) {
        return { type: `${actionPrefix}_FAILURE`, error };
    }

    function success() {
        return { type: 'CONTINUE_SUCCESS', qrCode, code: authenticationCode };
    }

    return async dispatch => {
        try {

            dispatch({ type: 'CONTINUE_REQUESTED', qrCode, authenticationCode });

            dispatch(progressActions.report(m.auth.loggingIn));

            const continueResponse = await repository.auth.continue(qrCode, authenticationCode);

            if (continueResponse.success) {

                // Signal and do the load of the card data
                dispatch(requestCardData(qrCode));
                dispatch(progressActions.report(m.cards.fetchingCard));

                const qrData = await repository.cards.getCardDataByQR(qrCode);

                if (!qrData || !qrData.cardData) {
                    dispatch(alertActions.warn(m.auth.noCardData, () => {

                        // Hide the modal window once the alert dialog is closed by the user
                        dispatch(progressActions.hide());
                    }));

                    return;
                }

                qrData.cardData.swipeType = swipeTypes.QR;
                qrData.cardData.dateRetrieved = new Date().toISOString();

                dispatch(receiveCardData(qrCode, qrData));

                const card = processCard(qrData);
                const hasWarning = isStringSet(card.warningMessage);

                if (card.canLogin && !hasWarning) {

                    // Update the worker process with the new serial number
                    updateCardSerial(qrData.serialNumber);

                    dispatch(progressActions.report(m.auth.loadingSiteData));
                    dispatch(progressActions.report(m.auth.refreshingDenyReasons));
                    const denyReasons = await repository.config.getDenyReasons();

                    dispatch(configActions.denyReasonsLoaded(denyReasons));

                    // Finally signal the user is logged in
                    dispatch(success());
                    dispatch(progressActions.hide());
                }
                else {
                    dispatch(signout());
                    dispatch(closeAuthCodeDialog());

                    const message = hasWarning ? m.auth.accessDeniedWithReason(card.warningMessage) : m.auth.permissionsError;

                    dispatch(alertActions.warn(message, () => {

                        // Hide the modal window once the alert dialog is closed by the user
                        dispatch(progressActions.hide());
                    }));
                }
            } else {
                dispatch(alertActions.error(continueResponse.failureReason || m.auth.invalidCode));
                dispatch(progressActions.hide());
            }
        }
        catch (error) {
            // Generic error handler, a number of different errors could have happened here
            dispatch(alertActions.error(error.failureReason || error.toString()));
            dispatch(failure(error.failureReason || error.toString()));
            dispatch(progressActions.hide());
        }
    };
}
